import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SaveProjectService } from 'src/app/core/services/save-project.service';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { ProjectApiService } from '../../core/services/project-api.service';
import { UserApiService } from '../../core/services/user-api.service';
import { ProjectService } from '../../core/services/project.service';
import { concatMap } from 'rxjs/operators';
import { MessageService } from '../../core/services/message.service';

@Component({
    selector: 'gl-new-project',
    templateUrl: './new-project.component.html',
    styleUrls: ['./new-project.component.scss'],
    standalone: false
})
export class NewProjectComponent implements OnInit {
  public form: UntypedFormGroup;
  public projectDescription: string;

  constructor(
    private modalRef: ModalOverlayRef,
    private projectApiService: ProjectApiService,
    private userApiService: UserApiService,
    private saveProjectService: SaveProjectService,
    private projectService: ProjectService,
    private messageService: MessageService,
  ) {
    this.projectDescription = this.saveProjectService.generateVisibleDescription();
    this.modalRef.backgroundClicked();
  }

  public ngOnInit() {
    this.form = this.saveProjectService.generateForm();
    this.projectApiService.getProjectInfo().subscribe((projectInfo) => {
      if (projectInfo && projectInfo.note) {
        this.form.controls['note'].setValue(projectInfo.note);
      }

      if (projectInfo && projectInfo.name) {
        this.form.controls['name'].setValue(projectInfo.name);
      }
    });
  }

  public onClose() {
    this.modalRef.close(null);
  }

  public newProjectWithoutSaving() {
    let unit: string = this.projectService.getState().options.unit;
    if (unit === 'mm') {
      unit = 'cm';
    }
    this.projectApiService
      .newProject()
      .pipe(
        concatMap(() =>
          this.projectApiService.projectOptionsUpdate({
            currentWorkSpaceId: 1,
            options: {
              unit,
            },
          }),
        ),
      )
      .subscribe(() => {
        this.messageService.sendMessage({ name: 'turnOffRecommendations' });
        this.modalRef.close('newProject');
      });
  }

  public newProjectWithSaving(): void {
    if (!this.form.valid) {
      return;
    }
    const projectData = {
      description: this.saveProjectService.generateProjectDescription(),
      name: this.form.get('name').value as string,
      note: this.form.get('note').value as string,
    };
    let unit: string = this.projectService.getState().options.unit;
    if (unit === 'mm') {
      unit = 'cm';
    }
    this.userApiService.saveProject(projectData).subscribe(() =>
      this.projectApiService.newProject().pipe(
        concatMap(() =>
          this.projectApiService.projectOptionsUpdate({
            currentWorkSpaceId: 1,
            options: {
              unit,
            },
          }),
        ),
      ).subscribe(() => {
        this.messageService.sendMessage({ name: 'turnOffRecommendations' });
        this.modalRef.close('newProject');
      }),

    );
  }
}
